import { render, staticRenderFns } from "./BatchPaymentBreakdownData.vue?vue&type=template&id=083c4ce8"
import script from "./BatchPaymentBreakdownData.vue?vue&type=script&lang=js"
export * from "./BatchPaymentBreakdownData.vue?vue&type=script&lang=js"
import style0 from "./BatchPaymentBreakdownData.vue?vue&type=style&index=0&id=083c4ce8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports